import React from "react";

import InlineProfilesLinkingDropdown from "./InlineProfilesLinkingDropdown";

import GQLUtil from "../../../global/utils/gqlHelper";
import PrefillUtil from "../../../global/utils/prefillHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";
import MappingResolver from "../../../data/schema/profiles/mappingResolver";
import util from "../../../global/utils/Helpers";

class InlinePrefiller extends React.Component {
  constructor() {
    super();
    this.state = {
      index: -1,
      selected: "-Select-",
    };
    this.selectProfile = this.selectProfile.bind(this);
    this.prefill = this.prefill.bind(this);
    this.profiles = [];
  }

  componentDidUpdate(prevProps) {
    if (this.props.schema !== prevProps.schema) {
      this.setState({
        index: -1,
      });
    }

    let filtered_profiles;
    if (this.props.profiles !== prevProps.profiles) {
      filtered_profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });
      this.setState({
        profiles: filtered_profiles,
      });
    }
  }

  componentDidMount() {
    let profiles;
    if (this.props.schemaProps.prefill) {
      profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });
      this.setState({ profiles });
    }
  }

  //TODO: get profiles
  selectProfile(value) {
    if (value === "-Select-") {
      this.setState({
        index: value,
        selected: value,
      });
    } else {
      this.setState({
        index: value,
        selected: this.state.profiles[value],
      });
    }
  }

  async prefill() {
    let formApi = this.props.formApi;
    //get the data
    const query = ViewEntityQueryResolver(
      this.state.selected.type,
      this.state.selected.id
    );
    const data = await GQLUtil.genericGQLQuery(query);
    const dataKeys = PrefillUtil.dataResolver(this.state.selected.type);
    let rawData = data.data[dataKeys.query][dataKeys.formDataName];
    //get the map
    const mapping = PrefillUtil.getPrefillSchemaMapping(
      this.state.selected.type,
      this.props.schemaProps.prefill.formName,
      this.props.schemaProps.prefill.formSection
    );
    const mappingSchema = MappingResolver(mapping);

    formApi.batch(() => {
      mappingSchema.fields.forEach((field) => {
        let value = util.setBadNaics(
          "employer",
          rawData,
          field.profileFieldName,
          rawData[field.profileFieldName]
        );

        let targetField = field.formTargetField;
        formApi.change(targetField, value);
      });
    });
  }

  render() {
    let showPrefiller = this.state.profiles && this.state.profiles.length > 0;
    return (
      <div style={{ display: showPrefiller ? "block" : "none" }}>
        <InlineProfilesLinkingDropdown
          id={`${this.props?.schemaProps?.prefill?.type}-${this.props?.schemaProps?.prefill?.formName}`}
          profiles={this.state.profiles}
          selectProfile={this.selectProfile}
          prefill={this.prefill}
          selected={this.state.selected}
          label={this.props.schemaProps.prefillLabel}
          key={this.props.schemaProps.prefillLabel}
          index={this.state.index}
        />
      </div>
    );
  }
}

export default InlinePrefiller;
